import Modal from "./accessibility";
import { documentReady, debouncer, playAudioSync, index, playBGMusic, pauseBGMusic } from "../Utility/utils";
import { addAnimScrollTrigger } from "./animations";
import {Howl, Howler} from 'howler';

documentReady((event) => {
  const body = document.querySelector("body");
  const intro = document.querySelector(".featured_intro");

  if (!!intro) {
    body.classList.add("featured-intro-open");
    body.insertBefore(intro, body.firstChild);
    const audio = intro.querySelector("audio");
    intro.classList.remove("complete");

    setTimeout(function () {
      playAudioSync(intro);

      // If the user hasn't interacted with the page, the audio won't play.
      // Let's check if the audio is playing, and if not, fade in a play button
      setTimeout(function () {
        if (audio.paused) {
          const playButton = intro.querySelector(".featured_intro__play");
          playButton.classList.remove("inactive");

          playButton.addEventListener("click", function (e) {
            playButton.blur();
            e.preventDefault();
            playAudioSync(intro);
            playButton.classList.add("clicked");
          });
        }
      }, 500);
    }, 700);

    audio.addEventListener("timeupdate", (event) => {
      // Update progress bar
      const progressBar = intro.querySelector(".site_intro__progress");
      const currentTime = event.srcElement.currentTime;
      const duration = event.srcElement.duration;
      const progress = (currentTime / duration) * 100;
      progressBar.style.setProperty("--progress", progress + "%");

      // Close modal when complete
      if (currentTime == duration) {
        intro.classList.add("complete");
        body.classList.remove("featured-intro-open");
        addAnimScrollTrigger();
      }
    });

    const skip = intro.querySelector(".featured_intro__skip");
    skip.addEventListener("click", (e) => {
      audio.pause();
      intro.classList.add("complete");
      body.classList.remove("featured-intro-open");
      addAnimScrollTrigger();
    });

    // Play BG Music
    if(window.backgroundMusic){
      playBGMusic();
    }
  }
});
